/**
 * AnimationTree registration: parser and property formatter.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseAnimationTree } from './parser';
import { formatAnimationTreeProperties } from './propertyFormatter';
const animationTreeRegistration = {
    typeName: 'AnimationTree',
    parser: parseAnimationTree,
    propertyFormatter: formatAnimationTreeProperties,
};
nodeRegistry.register(animationTreeRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map